import React, { ReactNode } from 'react';
import { Box, Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PageTitleBar, LoadingSpinner } from '@/components';
import { getMenuData } from '@core/data/menuData';
import AppCard from '@/components/appcard/AppCard';

interface ZoneTrackerPageLayoutProps {
    path: string;
    breadcrumbActive: string;
    titleSlot: string;
    loading: boolean;
    cardHeading: string;
    filterComponent: ReactNode;
    chartComponent: ReactNode;
}

const ZoneTrackerPageLayout: React.FC<ZoneTrackerPageLayoutProps> = ({
    path,
    breadcrumbActive,
    titleSlot,
    loading,
    cardHeading,
    filterComponent,
    chartComponent
}) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ width: '100%', minHeight: '100%', bgcolor: 'background.default' }}>
            <PageTitleBar
                menus={getMenuData()}
                currentRoute={{
                    path,
                    meta: {
                        breadcrumb: {
                            breadcrumbInactive: 'Statistics / Zone Tracker',
                            breadcrumbActive
                        }
                    }
                }}
                t={t}
                titleSlot={titleSlot}
            />
            <Container maxWidth={false} sx={{ py: 3 }}>
                {filterComponent}

                {loading ? (
                    <LoadingSpinner showBackground={false} />
                ) : (
                    <AppCard
                        heading={cardHeading}
                        icon="border_all"
                        iconClass=""
                        colClasses="flex col-12"
                        customClasses="mb-0"
                        fullBlock={false}
                        footer={false}
                    >
                        {chartComponent}
                    </AppCard>
                )}
            </Container>
        </Box>
    );
};

export default ZoneTrackerPageLayout;
